import React from 'react';
import { Quotes } from "./quotes";
import {Config} from "./config";

export function Admin() {
  return (
    <>
      <Config />
      <Quotes />
    </>
  )
}
